
/**
 * The type of level it is
 */
export const LevelType = {
  NORMAL: 'NORMAL',
  CHALLENGE: 'CHALLENGE',
};

/**
 * The type of treasure chest
 */
export const TreasureChestTypes = {
  TREASURE_HUNT: 'THGEM',
  CHEST: 'CHEST',
};
